package org.moxultimate.topwithmox.components.texts

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.vw
import org.moxultimate.topwithmox.theme.FontFamily
import org.moxultimate.topwithmox.theme.MaxDescriptionFontSize
import org.moxultimate.topwithmox.theme.MinDescriptionFontSize
import org.moxultimate.topwithmox.theme.WhiteTextColor

@Composable
fun DescriptionText(
    description: String,
    color: Color = WhiteTextColor,
    modifier: Modifier = Modifier,
) {
    SpanText(
        text = description,
        modifier = modifier
            .color(color)
            .fontFamily(FontFamily)
            .fontSize(clamp(min = MinDescriptionFontSize, value = 1.vw, max = MaxDescriptionFontSize))
            .fontWeight(FontWeight.Normal)
    )
}